/** @jsx jsx */
// eslint-disable-next-line
import React from 'react'
import { css, jsx } from '@emotion/core'
import { editingReminder } from '../actions/calendar'
import ReactTooltip from 'react-tooltip'
import { palette } from '../constants'
import propTypes from 'prop-types'
import { startTimeMin, endTimeMax } from './ReminderModal'

const styles = {
  day: css`
    background: ${palette.grey};
    pointer-events: all;
    position: relative;
  `,
  today: css`
    background: ${palette.lightBlue};
  `,
  hoverTrans: css`
    transition: transform 0.2s ease;
    &:hover {
      transform: scale(1.2);
      z-index: 1;
    }
  `,
  dayNumber: css`
    position: absolute;
    left: 50%;
    top: 2px;
    transform: translateX(-50%);
    font-weight: 600;
    font-size: 11px;
  `,
  remindersContainer: css`
    position: absolute;
    top: 16px;
    bottom: 3px;
    right: 3px;
    left: 16px;
    display: flex;
  `,
  reminderEvent: css`
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    position: relative;

    &:hover {
      box-shadow: inset 0 0 0 1px;
      opacity: 0.9;
    }
  `,
  leftItem: css`
    border-bottom-left-radius: 3px;
    border-top-left-radius: 3px;
  `,
  rightItem: css`
    border-bottom-right-radius: 3px;
    border-top-right-radius: 3px;
  `,
  hoursWrapper: css`
    display: flex;
    position: absolute;
    left: -14px;
    flex-direction: column;
    width: 12px;
    height: 100%;
    justify-content: space-between;
    font-size: 8px;
    align-items: flex-end;
    border: 1px solid ${palette.grey3};
    padding-right: 1px;
    border-left: 0;
    border-bottom-right-radius: 3px;
    border-top-right-radius: 3px;
  `,
  item: css`
    line-height: 9px;
  `,
  tooltipTitle: css`
    font-size: 7px;
    font-weight: bold;
    margin-bottom: 3px;
    padding-bottom: 4px;
    border-bottom: 1px dashed ${palette.grey3};
  `,
  tooltipBody: css`
    font-size: 8px;
  `,
}

const hours = [9, 12, 15, 18]
const toNumber = timeSting => Number(timeSting.split(':')[0])
const calcHeight = reminder => {
  const total = toNumber(endTimeMax) - toNumber(startTimeMin)
  const timeDif = toNumber(reminder.endTime) - toNumber(reminder.startTime)
  return `${(timeDif * 100) / total}%`
}
const calcTop = reminder => {
  const total = toNumber(endTimeMax) - toNumber(startTimeMin)
  const diff = toNumber(reminder.startTime) - toNumber(startTimeMin)
  return `${(diff * 100) / total}%`
}

function Day({ isToday, itemNumber, dayNumber, baseStyles, listReminders = [] }) {
  return (
    <div
      data-item-number={itemNumber}
      data-day-number={dayNumber}
      css={css`
        ${baseStyles};
        ${styles.day};
        ${isToday && styles.today};
        ${listReminders.length > 0 && styles.hoverTrans};
      `}
    >
      <div css={styles.dayNumber}>{dayNumber}</div>
      {listReminders.length > 0 && (
        <div css={styles.remindersContainer}>
          <div css={styles.hoursWrapper}>
            {hours.map(hour => (
              <div css={styles.item} key={hour}>
                {hour}
              </div>
            ))}
          </div>
          {listReminders.map((reminder, idx) => (
            <React.Fragment key={reminder.id}>
              <ReactTooltip id={reminder.id} place="top" effect="solid">
                <div css={styles.tooltipTitle}>
                  {reminder.startTime} - {reminder.endTime}
                </div>
                <div css={styles.tooltipBody}>{reminder.description}</div>
              </ReactTooltip>
              <div
                role="button"
                data-tip
                data-for={reminder.id}
                onClick={() => editingReminder(reminder)}
                css={css`
                  ${styles.reminderEvent};
                  background: ${reminder.color};
                  top: ${calcTop(reminder)};
                  height: ${calcHeight(reminder)};
                  ${idx === 0 && styles.leftItem};
                  ${idx === listReminders.length - 1 && styles.rightItem};
                `}
              />
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  )
}

Day.propTypes = {
  isToday: propTypes.bool.isRequired,
  itemNumber: propTypes.number.isRequired,
  dayNumber: propTypes.number.isRequired,
  baseStyles: propTypes.object.isRequired,
  listReminders: propTypes.array,
}

export default Day
